import React from "react";
import NuevaUnidadN from "./Actions/NuevaUnidadN";
import FilterTipoUser from "./Actions/FilterUnidadN";
import { Stack } from "@mui/material";
import TableUnidadN from "./Table/TableUnidadN";
import { OBTENER_UNIDADES_NEGOCIO } from "./graphql/queries";
import { useQuery } from "@apollo/client";
import { MainContext } from "../../../../Context/MainCtx";
import { useDebounce } from "use-debounce";

export default function UnidadesDeNegocio() {
  const [filter, setFilter] = React.useState("");
  const { tokenDecoded } = React.useContext(MainContext);
  const [FILTER] = useDebounce(filter, 800);

  const unidadQuery = useQuery(OBTENER_UNIDADES_NEGOCIO, {
    variables: {
      filter: FILTER,
      idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
    },
    fetchPolicy: "network-only",
  });

  return (
    <div>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ mb: 1, mt: 2, width: { xs: "100%", md: "50%" } }}
        bgcolor="background.paper"
      >
        <FilterTipoUser filter={filter} setFilter={setFilter} />
        <NuevaUnidadN refetch={unidadQuery.refetch} />
      </Stack>
      <TableUnidadN unidadQuery={unidadQuery} />
    </div>
  );
}
